import { ReceiptLinesTable } from '@krp/ui-kit'

import '../../../shared/uc1b/journals.css'
import { QueryState } from '../../../shared/uc1b/QueryState'
import type { ReceiptDetailVm, ReceiptLineVm } from '../model/types'

/**
 * Позиции чека AQSI компактной таблицей, как список номенклатуры: цена, ставка, предмет и мера — коды из самого чека; позиция с ключом
 * товара открывает карточку товара AQSI. Одни и те же в окне чека и под раскрытой строкой списка.
 */
export function ReceiptLines({ lines, openGood }: { lines: readonly ReceiptLineVm[]; openGood?: ((goodKey: string) => void) | undefined }) {
  if (lines.length === 0) return <p className="aqsi-journal__note">В чеке нет позиций.</p>
  return <ReceiptLinesTable lines={lines.map((line) => {
    const key = line.goodKey
    return {
      id: String(line.ordinal),
      name: line.name,
      quantity: line.quantityText,
      price: line.priceText,
      amount: line.amountText,
      unit: line.unitText,
      vat: line.vatText,
      subject: line.subjectText,
      barcode: line.barcode,
      returned: line.returnedText,
      ...(key === null || openGood === undefined ? {} : { open: () => openGood(key) }),
    }
  })} />
}

/** Товары чека AQSI под раскрытой строкой списка: пока чек читается — загрузка, отказ службы — дословно с «Повторить». */
export function ReceiptLinesPanel({ vm, onRetry, openGood }: { vm: ReceiptDetailVm; onRetry: () => void; openGood?: (goodKey: string) => void }) {
  return <>
    <QueryState query={vm.query} emptyText="Чек не найден" onRetry={onRetry} />
    {vm.detail !== null && <ReceiptLines lines={vm.detail.lines} openGood={openGood} />}
  </>
}
